/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseDictStrUnionStrNoneTypeData } from './genericApiResponseDictStrUnionStrNoneTypeData';
import type { GenericApiResponseDictStrUnionStrNoneTypeMessage } from './genericApiResponseDictStrUnionStrNoneTypeMessage';
import type { GenericApiResponseDictStrUnionStrNoneTypePagination } from './genericApiResponseDictStrUnionStrNoneTypePagination';
import type { GenericApiResponseDictStrUnionStrNoneTypeError } from './genericApiResponseDictStrUnionStrNoneTypeError';

export interface GenericApiResponseDictStrUnionStrNoneType {
  data?: GenericApiResponseDictStrUnionStrNoneTypeData;
  message?: GenericApiResponseDictStrUnionStrNoneTypeMessage;
  pagination?: GenericApiResponseDictStrUnionStrNoneTypePagination;
  error?: GenericApiResponseDictStrUnionStrNoneTypeError;
  statusCode?: number;
}
